import QUESTION_ICON from "@/assets/icons/question.svg";
import { FC } from "react";

interface HeaderColumnTooltipPropTypes {
  label: string;
  toolTipText: string;
  alignLabel?: "text-left" | "text-center" | "text-right";
}

const HeaderColumnTooltip: FC<HeaderColumnTooltipPropTypes> = ({
  label,
  toolTipText,
  alignLabel,
}) => {
  return (
    <th>
      <div
        className={
          "header-column-sort-wrapper" +
          (alignLabel ? ` ${alignLabel}` : " text-left")
        }
      >
        <label>{label}</label>
        <img
          title={toolTipText}
          src={QUESTION_ICON}
          alt="header-table-sort-icon"
        />
      </div>
    </th>
  );
};

export default HeaderColumnTooltip;
